import { createSlice } from "@reduxjs/toolkit";
import addBillingGeneralSettings from "@custom/rtk-apis/billing/addBillingGeneralSettings";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addBillingGeneralSettingsSlice = createSlice({
  name: "addBillingGeneralSettingsSlice",
  initialState,
  reducers: {
    clearHospitalBillingGeneralSettings: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBillingGeneralSettings.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addBillingGeneralSettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addBillingGeneralSettings.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addBillingGeneralSettingsSlice.reducer;
export const { clearHospitalBillingGeneralSettings } = addBillingGeneralSettingsSlice.actions;
